"use client";

import { ErrorContent } from "./_components/ErrorContent";

interface Props {
  error: Error & { digest?: string };
  reset: () => void;
}

export default function GlobalError({ reset }: Props) {
  return (
    <html lang="en">
      <body>
        <ErrorContent reset={reset} />
      </body>
    </html>
  );
}
